<template>
    <div class="container">
        <div class="pt-5">
            <h1 class="h3">Settings</h1>
            <div class="py-2">

                <settings-menu></settings-menu>
            </div>
            <div class="row py-3 border-bottom">
                    <div class="col-md-6 col-sm-12">
            <h3 class="h3">Receipt Preview</h3>

            </div>
            <div class="col-md-6 col-sm-12">

                </div>
                </div>

            <div class="container text-left mb-5">

                <!-- <template> -->
    <div id="print_invoice">
        <div class="ticket-container">
    <div class="ticket">
        <div v-if="companyDetails !==''" class="text-center">
            <img v-if="companyDetails.logo_url !==null"  class="centered" :src="companyDetails.logo_url" style="width: auto; height: auto; max-height:120px" alt="Logo">
            <p v-else  class="centered" >Logo</p>

        </div>
        <p class="centered text-center" v-if="companyDetails !==''">
            <span class="compan-details">{{companyDetails.name}}</span>
            <span v-if="companyDetails.phone !==null"><br>Phone:{{companyDetails.phone}}</span>
            <span v-if="companyDetails.email !==null"> <br>Email:{{companyDetails.email}}</span>
            <span v-if="companyDetails.address !==null"><br>Address:{{companyDetails.address}}</span>
            <span v-if="companyDetails.building !==null"><br>Location:{{companyDetails.building}}</span><span v-if="companyDetails.street !==''">{{companyDetails.street}}</span>
            <span v-if="companyDetails.town !==null"><br>Town:{{companyDetails.town}}</span>
            <span v-if="companyDetails.krapin !==null"><br>PIN:{{companyDetails.krapin}}</span>
        </p>
        <table class="table table-bordered">
            <thead>
            <tr>
                <th class="quantity">QTY</th>
                <th class="description">Description</th>
                <th class="price">{{companyDetails.companysettings.currency}}</th>
                <th >Totals</th>
            </tr>
            </thead>
            <tbody>
          <tr>
            <td>1</td>
                <td>Item 1</td>
                <td>100</td>
                <td>100</td>

          </tr>
          <tr>
            <td>2</td>
                <td>Item 2</td>
                <td>200</td>
                <td>400</td>

          </tr>
          <tr>
            <td>3</td>
                <td>Item 3</td>
                <td>300</td>
                <td>900</td>

          </tr>
         <tr>
            <td class="totals"><b>Sub-Total</b></td>
                <td class="totals"></td>
                <td class="totals"></td>
                <td class="totals" v-if="companyDetails.companysettings.enable_taxes"><b >{{companyDetails.companysettings.currency}} 1206.90</b></td>
                <td class="totals" v-else><b >{{companyDetails.companysettings.currency}} 1400</b></td>
         </tr>

            <tr v-if="companyDetails.companysettings.enable_discounts">
                <td class="totals"><b>Discounts</b></td>
                <td class="totals"></td>
                <td class="totals"></td>
                <td class="totals"><b >{{companyDetails.companysettings.currency}} 0</b></td>
         </tr>
         <tr v-if="companyDetails.companysettings.enable_taxes">

            <td class="totals"><b>VAT</b></td>
                <td class="totals"></td>
                <td class="totals"></td>
                <td class="totals"><b >{{companyDetails.companysettings.currency}} 193.10</b></td>
         </tr>
         <tr>
            <td class="totals"><b></b></td>
                <td class="totals"></td>
                <td class="totals"></td>
                <td class="totals"><b ></b></td>
         </tr>
         <tr>
            <td class="totals"><b>Total</b></td>
                <td class="totals"></td>
                <td class="totals"></td>
                <td class="totals"><b >{{companyDetails.companysettings.currency}} 1400</b></td>
         </tr>

            </tbody>
        </table>


        <p class="text-center">You were served by:
            <!-- <span class="text-capitalize" v-if="userDetails.full_name !== null">{{userDetails.full_name}}</span> -->
            <span class="text-capitalize">{{userDetails.full_name ?? userDetails.name}}</span>
            </p>
            <p class="text-center" v-if="companyDetails !==''" v-html="companyDetails.configs"></p>

            <p class="text-center" v-if="companyDetails.companysettings.receipt_footer_message !==null">{{ companyDetails.companysettings.receipt_footer_message }}</p>


    </div>
    </div>
    <div class="container text-center">
        <a class="btn btn-primary print-action">Print Receipt</a>
    </div>
</div>
<!-- </template> -->

<!-- <script>
    export default {
        name: "invoice",
        props: [
            'order',
            'orderitems',

            'user',

        ],
        mounted() {
            this.PrintInvoice();
        },
        methods: {
            PrintInvoice()
            {
                // window.print();
                this.$htmlToPaper('print_invoice');
            }
        }
    }
</script>

<style scoped>


    .ticket-container {

            max-width: 100%;
            width: 100%;
        }
        .ticket{
            width: 100%;
        }
        .table td, .table th {
    padding: 1px !important
  }

</style> -->

            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: "profile",
        data() {
            return {
                companyDetails:{
                    companysettings:{}
                },
                userDetails:{}
            }
        },
        mounted() {
            this.getUserCompanyDetails()
        },
        methods: {
            changeCompanyLogo(e) {
                e.preventDefault();
                let imagefilename = document.getElementById('filename').value;
                axios.post('/api/update-company-logo', {
                        companyId: this.companyDetails.id,
                        companyLogo: imagefilename
                    })
                    .then(result => {
                        this.$refs['editprofile'].hide()
                        this.$toasts.push({
                            type: 'success',
                            message: result.data.message
                        })
                    }).catch(errors => {
                        console.log(errors.message)
                    });
            },
            getUserCompanyDetails() {
                axios.get('/api/user')
                    .then(result => {
                        this.companyDetails = result.data.company
                        this.userDetails = result.data
                    }).catch(errors => {
                        console.log(errors.message)
                    });
            },
            saveCompanyDetails() {
                axios.post('/api/update-company', { ...this.companyDetails
                }).then(results => {
                    this.$toasts.push({
                        type: 'success',
                        message: "Company details have updated"
                    })
                }).catch(errors => {
                })
            },
            splitReceiptConfig(string){
                return string
            },
        },
    }
</script>

<style scoped>

</style>
